"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreambleLogoWhite = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../styles");

var PreambleLogo = function PreambleLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("title", null, "CivicPlus Preamble"), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#3A7470",
    d: "M22.5 0L0 11.25v22.5l7.5 3.75V15l15-7.5 15 7.5v15l-15 7.5-7.5-3.75v7.5L22.5 45 45 33.75v-22.5L22.5 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#3A7470",
    d: "M30 26.25v-7.5L22.5 15 15 18.75v7.5L22.5 30l7.5-3.75zM93.32 14.4v14.4c0 3.24-3 5.85-6.68 5.85H68.55V45H63V8.55h23.64c3.7 0 6.68 2.61 6.68 5.85zm-5.55 0a1.07 1.07 0 0 0-1.13-1h-17a1.07 1.07 0 0 0-1.13 1v14.4a1.07 1.07 0 0 0 1.13 1h17a1.07 1.07 0 0 0 1.13-1zM120.86 8.55v4.86h-16.65a1.08 1.08 0 0 0-1.13 1v20.24h-5.55V14.4c0-3.24 3-5.85 6.68-5.85zM154.11 14.4V24h-24.77v4.8a1.08 1.08 0 0 0 1.13 1h23.64v4.86h-23.64c-3.7 0-6.68-2.61-6.68-5.85V14.4c0-3.24 3-5.85 6.68-5.85h17c3.66 0 6.64 2.61 6.64 5.85zm-5.55 4.77V14.4a1.07 1.07 0 0 0-1.13-1h-17a1.08 1.08 0 0 0-1.13 1v4.77zM189.72 14.4v20.25h-23.64c-3.7 0-6.68-2.61-6.68-5.85v-9.63h24.77V14.4a1.07 1.07 0 0 0-1.13-1H159.4V8.55H183c3.74 0 6.72 2.61 6.72 5.85zm-5.55 9.6H165v4.8a1.08 1.08 0 0 0 1.13 1h18.09zM238.54 14.4v20.25H233V14.4a1.09 1.09 0 0 0-1.18-1h-11.73a1.08 1.08 0 0 0-1.13 1v20.25h-5.55V14.4a1.07 1.07 0 0 0-1.13-1h-11.82a1.08 1.08 0 0 0-1.13 1v20.25h-5.55V8.55h38.08c3.7 0 6.68 2.61 6.68 5.85zM274.36 14.4v14.4c0 3.24-3 5.85-6.68 5.85H244V0h5.55v8.55h18.09c3.74 0 6.72 2.61 6.72 5.85zm-5.55 0a1.07 1.07 0 0 0-1.13-1h-17a1.07 1.07 0 0 0-1.13 1v14.4a1.07 1.07 0 0 0 1.13 1h17a1.07 1.07 0 0 0 1.13-1zM278.21 0h5.55v28.8a1.08 1.08 0 0 0 1.13 1h5.55v4.86h-5.55c-3.7 0-6.68-2.61-6.68-5.85V0zM324 14.4V24h-24.77v4.8a1.07 1.07 0 0 0 1.13 1H324v4.86h-23.64c-3.7 0-6.68-2.61-6.68-5.85V14.4c0-3.24 3-5.85 6.68-5.85h17c3.64 0 6.64 2.61 6.64 5.85zm-5.55 4.77V14.4a1.07 1.07 0 0 0-1.13-1h-17a1.07 1.07 0 0 0-1.13 1v4.77z"
  }));
};

PreambleLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 324 45"
};
var _default = PreambleLogo;
exports.default = _default;

var PreambleLogoWhite = function PreambleLogoWhite(_ref) {
  var className = _ref.className,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  var classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(PreambleLogo, (0, _extends2.default)({
    className: (0, _classnames.default)(className, classes.root)
  }, otherProps));
};

exports.PreambleLogoWhite = PreambleLogoWhite;